import { render, staticRenderFns } from "./ApplicantRepLegalAddress.vue?vue&type=template&id=02c6d34d&"
import script from "./ApplicantRepLegalAddress.vue?vue&type=script&lang=js&"
export * from "./ApplicantRepLegalAddress.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantRepLegalAddress.vue?vue&type=style&index=0&id=02c6d34d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports